import Axios from "axios";
import { saveUpdateEmployeeSetup } from "@/store/api";
// initial state
const state = {
  editingEmployee: null,
};

const getters = {
  getEditingEmployee:(state) =>{
    return state.editingEmployee;
  },
};

const mutations = {
  setEditingEmployee(state, employee) {
    state.editingEmployee = employee;
  },
};

const actions = {

  saveUpdateEmployeeSetup({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateEmployeeSetup, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
